'use client';
import React, { useState } from 'react';
import { IoMdClose } from 'react-icons/io';
import { GiHamburgerMenu } from 'react-icons/gi';
import { FaSearch } from 'react-icons/fa';
import ButtonCommon from '../button-common/button-common';
import DrawerHeader from '../drawer-header/drawer-header';
import Drawer from 'react-modern-drawer';
import 'react-modern-drawer/dist/index.css';
import { useRouter } from 'next/navigation';

function InputSearch() {
  const router = useRouter();
  const [valueSearch, setValueSearch] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };
  const handleKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      router.push(`/tim-kiem?name=${valueSearch}`);
    }
  };
  const searchMovie = () => {
    if (valueSearch) {
      router.push(`/tim-kiem?name=${valueSearch}`);
    }
  };
  return (
    <div className="flex gap-x-2">
      <div className="relative">
        <input
          placeholder="Tìm kiếm phim..."
          value={valueSearch}
          onKeyUp={handleKeyPress}
          onChange={(event) => {
            setValueSearch(event.target.value);
          }}
          className="h-10 px-7 w-[230px] max-md:w-40 border border-solid rounded border-colorMainOver bg-colorMain text-white text-[13px]"
        />
        <FaSearch
          color="white"
          size={16}
          className="absolute top-3 left-2"
          onClick={() => {
            router.push(`/tim-kiem?name=${valueSearch}`);
          }}
        />
        {valueSearch && (
          <IoMdClose
            color="white"
            size={18}
            className="absolute top-3 right-1 cursor-pointer"
            onClick={() => {
              setValueSearch('');
            }}
          />
        )}
      </div>
      <div className="max-lg:hidden">
        <ButtonCommon
          text="Tìm kiếm"
          onClick={() => {
            searchMovie();
          }}
        />
      </div>
      <div
        className="hidden max-lg:flex items-center justify-center p-2 px-3 bg-redMain rounded cursor-pointer"
        onClick={toggleDrawer}
      >
        <GiHamburgerMenu color="white" />
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className="bla bla bla"
      >
        <DrawerHeader />
      </Drawer>
    </div>
  );
}

export default InputSearch;
